<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <div>
              <v-alert :type="alertType" v-model="alert" border="left" dismissible>{{alertMsg}}</v-alert>
            </div>

            <login v-if="!register" @register="register=!register" @logged="$emit('logged')" @alert="setAlert"></login>
            <register v-if="register" @back="register=!register" @alert="setAlert" @registered="registered"></register>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import LoginComponent from "./Login";
import RegisterComponent from "./Register";

export default {
  components: {
    login: LoginComponent,
    register: RegisterComponent
  },
  data() {
    return {
      alert: false,
      alertMsg: "",
      alertType: 'error',
      register: false,
    };
  },
  methods: {
    setAlert: function(value) {
      this.alertMsg = value;
      this.alert = true;
      this.alertType = 'error';
    },
    registered: function(){
      this.alertMsg = this.$t("Login.Alert.success");
      this.alert = true;
      this.alertType = 'success';
      this.register = false;
    }
  }
};
</script>